module.exports = __webpack_public_path__ + "img/s0.707aecd7.png";